/*!

=========================================================
* Paper Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";	// reactstrap components


class Local extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			connectables: []
		};

		this.handleClick = this.handleClick.bind(this);
	}

	componentDidMount() {
		// this.intervalConnectables = setInterval(() => this.getConnectables(), 60*1000);	// every 60 seconds update the battery levels
	}

	handleClick( whichDevice, whichState ) {
	}

	render() {
		return (
		  <>
			<div className="content">
			  <Row>
				<Col md="12">
				  <Card>
					<CardHeader>
					  <h3 className="title"> Bird Cam on our back porch </h3>
					</CardHeader>
					<CardBody className="card-body align-items-center d-flex justify-content-center" style={{marginBottom:30}}>
						<img alt="camera1" src="http://home.beccue.com:8081/0/stream" />
					</CardBody>
				  </Card>
				</Col>
			  </Row>
			</div>
		  </>
		);
	}
}

export default Local;
